import React from "react";
import { useLocation } from "react-router-dom";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import AppFooter from "./AppFooter";
import { MobileHomeButton, shouldShowMobileHome } from "./MealsPageChrome";

/** Minimal shell for routes outside AppLayout (help, legal, shared links). Follows theme. */
export default function StandaloneLayout({ children, sx }) {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const showHome = isMobile && shouldShowMobileHome(location.pathname);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        bgcolor: "background.default",
        color: "text.primary",
        ...sx,
      }}
    >
      <Box sx={{ flex: 1 }}>{children}</Box>
      {showHome ? null : <AppFooter />}
      {showHome ? <MobileHomeButton /> : null}
    </Box>
  );
}
